import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-standing__league-info"
}
const _hoisted_2 = { class: "as-league_title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "as-standing__table-row as-standing__table-row-head" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "as-standing__table-column as-column-performance as-text-center as-coulumn-show-full" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "as-match__team" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "as-standing__table-text" }
const _hoisted_11 = { class: "as-standing__table-column as-justify-content-center" }
const _hoisted_12 = { class: "as-standing__table-column as-justify-content-center" }
const _hoisted_13 = { class: "as-standing__table-column as-justify-content-center" }
const _hoisted_14 = { class: "as-standing__table-column as-justify-content-center" }
const _hoisted_15 = { class: "as-standing__table-column as-justify-content-center as-coulumn-show-full" }
const _hoisted_16 = { class: "as-standing__table-column as-justify-content-center as-coulumn-show-full" }
const _hoisted_17 = { class: "as-standing__table-column as-justify-content-center" }
const _hoisted_18 = { class: "as-standing__table-column as-justify-content-center as-coulumn-show-full" }
const _hoisted_19 = { class: "as-standing-tag__list" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "as-standing__table-column as-justify-content-center as-coulumn-show-full" }
const _hoisted_22 = ["onClick", "src", "alt", "title"]
const _hoisted_23 = {
  key: 0,
  class: "as-promotion"
}

import { ref, computed, onMounted, nextTick } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import NoData from "~src/components/NoData.vue";
import DropdownToggle from "~src/components/DropdownToggle.vue";
import type {
  IStanding,
  IMatch,
  ILeague,
  ISeason,
  IStandingsRow,
  IStandingsTable,
  IPromotion,
  IRecent,
} from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  determineMatchResult,
  getCompetitionNameShow,
  getTeamName,
  getCupStage,
} from "~src/helpers";
import IconArrowRight from "../icons/IconArrowRight.vue";
import StandingLiveScore from "~src/components/standings/StandingLiveScore.vue";


const __default__ = {};

interface IProps {
  standing: IStanding;
  match?: IMatch;
  league?: ILeague;
  isPopup: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StandingList',
  props: {
    standing: {},
    match: {},
    league: {},
    isPopup: { type: Boolean, default: true }
  },
  emits: [
  "changeSeason"
],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const isShowFull = ref(false);
const activeTab = ref("all");

const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: "Sân nhà",
    key: "home",
  },
  {
    title: "Sân khách",
    key: "away",
  },
]);

const columns = [
  {
    title: "#",
    name: "position",
    class: "as-justify-content-center as-standing__table-column-stt as-column-head",
  },
  {
    title: "Đội bóng",
    name: "team_name",
    class: "as-standing__table-column-team as-column-head as-text-left",
  },
  {
    title: "Trận",
    name: "total",
    class: "as-justify-content-center as-c-total",
  },
  {
    title: "W",
    name: "won",
    class: "as-justify-content-center as-c-w",
  },
  {
    title: "D",
    name: "draw",
    class: "as-justify-content-center as-c-d",
  },
  {
    title: "L",
    name: "loss",
    class: "as-justify-content-center as-c-l",
  },
  {
    title: "G",
    name: "goals",
    class: "as-justify-content-center as-c-g as-coulumn-show-full",
  },
  {
    title: "HSBT",
    name: "goal_diff",
    class: "as-justify-content-center as-c-hsbt as-coulumn-show-full",
  },
  {
    title: "Điểm",
    name: "points",
    class: "as-justify-content-center as-c-point",
  },
];

const sort = ref({
  column: "",
  type: "ASC",
});

const promotions = computed(() => {
  return props.standing.standings.promotions;
});

const tables = computed(() => {
  if (!props.standing?.standings) {
    return [];
  }

  const datas = [];
  for (const table of props.standing.standings.tables) {
    const rows = [];
    for (const row of table.rows) {
      rows.push({
        ...row,
        team_name: getTeamName(props.standing.teams, row.team_id),
      });
    }
    datas.push({
      ...table,
      rows,
    });
  }

  return datas;
});

const body = ref<HTMLDivElement | null>(null);

onMounted(async () => {
  await nextTick();
  body.value = document.querySelector(".as-parent-standing");
});

const scrollToActiveItem = (container: HTMLDivElement, activeItem: HTMLDivElement) => {
  try {
    if (!container || !activeItem) return;

    const containerRect = container.getBoundingClientRect();
    const activeItemRect = activeItem.getBoundingClientRect();

    const scrollLeft = container.scrollLeft + activeItemRect.left - containerRect.left;

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  } catch (error) {
    console.error('Error in scrollToActiveItem:', error);
  }
}

const handleShowFull = async () => {
  isShowFull.value = !isShowFull.value;
  await nextTick();

  if (isShowFull.value && body.value) {
    const _tables = body.value.querySelectorAll<HTMLDivElement>(".as-standing__table") ?? [];
    if (!_tables?.length) return;

    Array.from(_tables).forEach((table) => {
      try {
        const activeItem = table.querySelector<HTMLDivElement>(".as-scroll-item-active");
        if (!activeItem) return;

        requestAnimationFrame(() => {
          setTimeout(() => {
            scrollToActiveItem(table as HTMLDivElement, activeItem);
          }, 100);
        });
      } catch (error) {
        console.error('Error scrolling to active item:', error);
      }
    });
  }
};

const changeTab = (val: string) => {
  activeTab.value = val;
};

const changeSeason = (season: ISeason) => {
  emits("changeSeason", season.id);
};

const getRows = (rows: Array<IStandingsRow>) => {
  return rows?.sort((a: any, b: any) => {
    if (activeTab.value === "all") {
      // chọn sắp xếp
      if (sort.value.column) {
        // sắp xếp string
        if (sort.value.column === "team_name") {
          if (sort.value.type === "DESC") {
            return a.team_name.localeCompare(b.team_name);
          } else {
            return b.team_name.localeCompare(a.team_name);
          }
        } else {
          if (sort.value.type === "DESC") {
            return a[sort.value.column] - b[sort.value.column];
          } else {
            return b[sort.value.column] - a[sort.value.column];
          }
        }
      } else {
        return a.position - b.position;
      }
    } else {
      if (sort.value.column) {
        if (sort.value.column === "team_name") {
          if (sort.value.type === "DESC") {
            return a.team_name.localeCompare(b.team_name);
          } else {
            return b.team_name.localeCompare(a.team_name);
          }
        } else {
          if (sort.value.type === "DESC") {
            return (
              a[`${activeTab.value}_${sort.value.column}`] -
              b[`${activeTab.value}_${sort.value.column}`]
            );
          } else {
            return (
              b[`${activeTab.value}_${sort.value.column}`] -
              a[`${activeTab.value}_${sort.value.column}`]
            );
          }
        }
      } else {
        return (
          a[`${activeTab.value}_position`] - b[`${activeTab.value}_position`]
        );
      }
    }
  });
};

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const getStyleStt = (promotion_id: string) => {
  const promotion = props.standing.standings.promotions.find(
    (item: IPromotion) => item.id == promotion_id
  );

  if (promotion) {
    return {
      backgroundColor: promotion.color,
      color: getContrastColor(promotion.color),
      fontWeight: 700,
    };
  }

  return {};
};

const getGroupName = (table: IStandingsTable) => {
  if (!table.stage || tables.value.length === 1) {
    return "Đội bóng";
  }

  const match = {
    stage: table.stage,
    round: {
      group_num: table.group,
      round_num: 0,
      stage_id: table.stage_id,
    },
  } as IMatch;
  const stageName = getCupStage(match);

  return stageName ? stageName : "Đội bóng";
};

const getRowdata = (row: IStandingsRow, field: string) => {
  if (field === "total") {
    if (activeTab.value === "all") {
      return row.total;
    } else if (activeTab.value === "home") {
      return row.home_total;
    } else {
      return row.away_total;
    }
  } else if (field === "won") {
    if (activeTab.value === "all") {
      return row.won;
    } else if (activeTab.value === "home") {
      return row.home_won;
    } else {
      return row.away_won;
    }
  } else if (field === "draw") {
    if (activeTab.value === "all") {
      return row.draw;
    } else if (activeTab.value === "home") {
      return row.home_draw;
    } else {
      return row.away_draw;
    }
  } else if (field === "loss") {
    if (activeTab.value === "all") {
      return row.loss;
    } else if (activeTab.value === "home") {
      return row.home_loss;
    } else {
      return row.away_loss;
    }
  } else if (field === "goals") {
    if (activeTab.value === "all") {
      return row.goals;
    } else if (activeTab.value === "home") {
      return row.home_goals;
    } else {
      return row.away_goals;
    }
  } else if (field === "goals_against") {
    if (activeTab.value === "all") {
      return row.goals_against;
    } else if (activeTab.value === "home") {
      return row.home_goals_against;
    } else {
      return row.away_goals_against;
    }
  } else if (field === "goal_diff") {
    if (activeTab.value === "all") {
      return row.goal_diff;
    } else if (activeTab.value === "home") {
      return row.home_goal_diff;
    } else {
      return row.away_goal_diff;
    }
  } else if (field === "points") {
    if (activeTab.value === "all") {
      return row.points;
    } else if (activeTab.value === "home") {
      return row.home_points;
    } else {
      return row.away_points;
    }
  }
};

const getRecentTitle = (recent: IRecent) => {
  return `${recent.home_scores[0]}:${recent.away_scores[0]} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-standing as-parent-standing as-parent-standing-${_ctx.gSiteName}`)
  }, [
    (_ctx.league)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "as-lazyload",
              src: _ctx.getImgUrlBySport('competition', _ctx.league.id)
            }, null, 8, _hoisted_3),
            _createTextVNode(_toDisplayString(_unref(getCompetitionNameShow)(_ctx.league)), 1)
          ]),
          _createVNode(DropdownToggle, {
            data: _ctx.league.seasons,
            idActive: _ctx.league.cur_season_id,
            onHandleChoose: changeSeason
          }, null, 8, ["data", "idActive"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.standing && tables.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-standing__top", {
          'as-standing__tabs-center': _ctx.isPopup,
        }])
          }, [
            _createVNode(TabsBtn, {
              tabs: tabs.value,
              activeTab: activeTab.value,
              onChange: changeTab
            }, null, 8, ["tabs", "activeTab"]),
            _createElementVNode("div", {
              class: _normalizeClass(["as-menu", {
            'as-active': isShowFull.value,
          }]),
              onClick: handleShowFull
            }, [
              _createVNode(IconMenu)
            ], 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass({
          'as-show-full': isShowFull.value,
          'as-scrolling as-scrolling__have-tab as-scrolling__result-popup':
            _ctx.isPopup,
        })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tables.value, (table, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "as-standing__table"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                    return _createElementVNode("div", {
                      key: column.name,
                      onClick: ($event: any) => (sortData(column.name)),
                      class: _normalizeClass(`as-standing__table-column ${column.class}`),
                      type: "button"
                    }, [
                      _createTextVNode(_toDisplayString(column.name === "team_name" ? getGroupName(table) : column.title) + " ", 1),
                      (sort.value.column === column.name)
                        ? (_openBlock(), _createBlock(IconArrownDown, {
                            key: 0,
                            class: _normalizeClass(["as-d-inline-flex", {
                  'as-sort-down': sort.value.type === 'ASC',
                  'as-sort-up': sort.value.type === 'DESC',
                }])
                          }, null, 8, ["class"]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_5)
                  }), 64)),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[0] || (_cache[0] = _createTextVNode(" Phong độ ")),
                    _createVNode(IconArrowRight)
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-standing__table-column as-column-next as-scroll-item-active as-justify-content-center as-coulumn-show-full" }, " Tiếp ", -1))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRows(table.rows), (row, keyRow) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: keyRow,
                    class: _normalizeClass(["as-standing__table-row", {
              active:
                _ctx.match?.home_team_id === row.team_id ||
                _ctx.match?.away_team_id === row.team_id,
            }])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["as-standing__table-column as-standing__table-column-stt as-text-center", {
                'as-stt-popup': _ctx.isPopup,
              }])
                    }, [
                      _createElementVNode("div", {
                        class: "as-stt",
                        style: _normalizeStyle(getStyleStt(row.promotion_id))
                      }, _toDisplayString(row.position), 5)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["as-standing__table-column as-standing__table-column-team", {
                'as-team-popup': _ctx.isPopup,
              }])
                    }, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.getLinkTeamDetail(row.team_id, row.team_name, true)),
                        class: _normalizeClass(["as-match__team-group", {
                  'as-match__team-group-live': row.live_score
                }])
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("img", {
                            src: _ctx.getImgUrlBySport('team', row.team_id),
                            class: "as-match__team-logo",
                            alt: row.team_name
                          }, null, 8, _hoisted_9),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(row.team_name), 1)
                        ]),
                        (row.live_score)
                          ? (_openBlock(), _createBlock(StandingLiveScore, {
                              key: 0,
                              standing: row
                            }, null, 8, ["standing"]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_7)
                    ], 2),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(getRowdata(row, "total")), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(getRowdata(row, "won")), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(getRowdata(row, "draw")), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(getRowdata(row, "loss")), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(getRowdata(row, "goals")) + ":" + _toDisplayString(getRowdata(row, "goals_against")), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(getRowdata(row, "goal_diff")), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(getRowdata(row, "points")), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRecent(row), (recent, keyRecent) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: keyRecent,
                            class: _normalizeClass(`as-standing-tag as-standing-tag__${_unref(determineMatchResult)(
                    recent,
                    row.team_id
                  ).charAt(0)}`),
                            title: getRecentTitle(recent)
                          }, _toDisplayString(_unref(determineMatchResult)(recent, row.team_id).charAt(0)), 11, _hoisted_20))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      (row.next_match)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            onClick: ($event: any) => (
                  _ctx.showTeamInfo(
                    row.next_match.away_team.id === row.team_id
                      ? row.next_match.home_team.id
                      : row.next_match.away_team.id
                  )
                ),
                            src: 
                  _ctx.getImgUrlBySport(
                    'team',
                    row.next_match.away_team.id === row.team_id
                      ? row.next_match.home_team.id
                      : row.next_match.away_team.id
                  )
                ,
                            class: "as-match__team-logo as-cursor-pointer",
                            alt: 
                  row.next_match.away_team.id === row.team_id
                    ? row.next_match.home_team.name
                    : row.next_match.away_team.name
                ,
                            title: 
                  row.next_match.away_team.id === row.team_id
                    ? row.next_match.home_team.name
                    : row.next_match.away_team.name
                
                          }, null, 8, _hoisted_22))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ]))
            }), 128)),
            (promotions.value && promotions.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotions.value, (promotion, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "as-promotion-item"
                    }, [
                      _createElementVNode("div", {
                        class: "as-promotion-circle",
                        style: _normalizeStyle({
                background: promotion.color,
              })
                      }, null, 4),
                      _createTextVNode(" " + _toDisplayString(promotion.name), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 64))
      : (_openBlock(), _createBlock(NoData, { key: 2 }))
  ], 2))
}
}

})